import ciJson from "./ci.json" with { type: "json" };
import { ciSchema, type CI } from "./schema";

export const ci: CI = ciSchema.parse(ciJson);

export const colors = ci.colors;

export type ColorTheme = "dark" | "light";

/**
 * Dark/Light-Paletten. Die Light-Werte stammen 1:1 aus www.allyver.com
 * (`/css/theme.css`, `[data-theme="light"]`): weiches Off-White als Fläche,
 * fast-schwarze Headline-Tinte, dunkleres Muted für Lesbarkeit. Die
 * Akzentfarben (primary/secondary/accent) sind in BEIDEN Themes identisch —
 * sie poppen auf hell wie auf dunkel.
 */
const darkPalette = { bg: ci.colors.bg, fg: ci.colors.fg, muted: ci.colors.muted };
const lightPalette = { bg: "#f4f6fa", fg: "#0f172a", muted: "#5b6678" };

/** CI-Default-Theme (aus ci.json) — Fallback für Restore nach dem Build. */
export const defaultColorTheme: ColorTheme = ci.theme === "light" ? "light" : "dark";
export let activeColorTheme: ColorTheme = defaultColorTheme;

/**
 * Schaltet die geteilte Brand-Palette (bg/fg/muted) zwischen Dark und Light um.
 *
 * Smart & szenen-übergreifend: Alle ~116 Szenen + Backdrops lesen `colors.*`
 * bzw. `ci.colors.*` zur BUILD-Zeit (in ihren Builder-Funktionen). Ein
 * Umschalten VOR dem (synchronen) Reel-Build wirkt deshalb global für jede
 * Szene — ohne dass eine einzelne Szene angefasst werden muss. `buildReelHtml`
 * setzt das Theme pro Reel und stellt danach den CI-Default wieder her.
 */
export function setColorTheme(theme: ColorTheme): void {
  const p = theme === "light" ? lightPalette : darkPalette;
  colors.bg = p.bg;
  colors.fg = p.fg;
  colors.muted = p.muted;
  activeColorTheme = theme;
}

// CI-Default beim Modul-Load anwenden (i. d. R. "dark").
setColorTheme(defaultColorTheme);
export const fonts = ci.fonts;
export const brandName = ci.name;
export const brandUrl = ci.url;
export const brandTagline = ci.tagline;
export const brandUsp = ci.usp;

export const radii = {
  sm: 8,
  md: 16,
  lg: 28,
  xl: 44,
  pill: 9999,
};

export const shadows = {
  card: "0 24px 64px rgba(0, 0, 0, 0.35)",
  glow: `0 0 80px ${ci.colors.primary}55`,
};
